import { useFlags } from 'launchdarkly-react-client-sdk';
import Layout from '../../components/Layout';
import Banner from './Banner';
import HowItWorks from './HowItWorks';
import MoreInfo from './MoreInfo';
import './styles.css';

const SupplierDiversity = () => {
  const { chatbotAppliedLab: showChatbot } = useFlags();

  return (
    <Layout hideChatWidget={!showChatbot}>
      <Banner />
      <HowItWorks />
      <MoreInfo />
    </Layout>
  );
};

export default SupplierDiversity;
